module.exports = __webpack_public_path__ + "img/Musha.11cb1a1f.jpg";